// ClientApp/src/apps/components/tests/SsoAuthVerificationFlow/utils/niogemsPayload.js

/**
 * Parses embedded JSON out of a niogemsAuth "message" value, which may
 * arrive as:
 *  - an already-parsed object (returned as-is)
 *  - a string containing a JSON blob embedded inside other text
 *  - anything else / unparsable (returns null)
 */
export function parseNiogemsPayload(message) {
  if (!message) return null;

  if (typeof message === "object") return message;

  if (typeof message === "string") {
    const jsonStartIndex = message.indexOf("{");
    const jsonEndIndex = message.lastIndexOf("}");

    if (jsonStartIndex !== -1 && jsonEndIndex !== -1) {
      try {
        const jsonSubstring = message.substring(jsonStartIndex, jsonEndIndex + 1);
        return JSON.parse(jsonSubstring);
      } catch (e) {
        console.warn("Could not parse payload JSON:", e);
      }
    }
  }

  return null;
}

/**
 * True when the NIOGEMS API explicitly returned a "display" action
 * with an "Active" status (e.g. "Active (Dev Mode)" in dev flow).
 */
export function isNiogemsApproved(niogemsAuth) {
  return Boolean(
    niogemsAuth?.action === "display" && niogemsAuth?.status?.includes("Active")
  );
}

/**
 * True when the API returned a "display" action but the status is
 * NOT active (NotExist, Pending, Denied, SystemError, etc).
 */
export function isNiogemsDenied(niogemsAuth) {
  return Boolean(
    niogemsAuth?.action === "display" && !niogemsAuth?.status?.includes("Active")
  );
}

/** Renders a message for single-line display: objects are JSON.stringify'd. */
export function formatMessage(message) {
  return typeof message === "object" ? JSON.stringify(message) : message;
}

/** Renders a message for multi-line/pretty display (2-space indented JSON). */
export function formatMessagePretty(message) {
  return typeof message === "object" ? JSON.stringify(message, null, 2) : message;
}

/** Renders a single parsed-payload value for display: null/object/primitive. */
export function formatPayloadValue(value) {
  if (value === null) return "null";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}